import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
  completedSteps: boolean[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  completedSteps
}) => {
  const steps = [
    { id: 1, name: 'Sign Up', icon: 'user' },
    { id: 2, name: 'Choose Plan', icon: 'plan' },
    { id: 3, name: 'Verify Phone', icon: 'phone' },
    { id: 4, name: 'Payment', icon: 'payment' }
  ];

  const renderIcon = (iconType: string, isActive: boolean, isCompleted: boolean) => {
    const iconStyle = `w-4 h-4 ${isActive || isCompleted ? 'text-white' : 'text-gray-500'}`;
    
    switch (iconType) {
      case 'user':
        return (
          <div className="w-6 h-6 bg-current rounded-sm"></div>
        );
      case 'plan':
        return (
          <div className="relative">
            <div className="w-5 h-5 border-2 border-current rounded-sm"></div>
            <div className="absolute top-1 left-1 w-2 h-2 bg-current"></div>
          </div>
        );
      case 'phone':
        return (
          <div className="w-4 h-6 border-2 border-current rounded-sm relative">
            <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-0.5 bg-current"></div>
          </div>
        );
      case 'payment':
        return (
          <div className="relative">
            <div className="w-6 h-4 border-2 border-current rounded-sm"></div>
            <div className="absolute top-1 left-1 w-1 h-1 bg-current rounded-full"></div>
          </div>
        );
      default:
        return <div className="w-4 h-4 bg-current"></div>;
    }
  };

  return (
    <div className="relative mb-4">
      {/* Connecting line between steps */}
      <div className="absolute top-6 left-12 right-12 h-0.5 bg-gray-200"></div>
      
      <div className="flex items-center justify-between relative px-6">
        {steps.map((step, index) => (
          <div key={step.id} className="flex flex-col items-center relative">
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-500 relative z-10 ${
                currentStep === step.id
                  ? 'bg-black text-white shadow-lg scale-110 ring-4 ring-gray-200'
                  : completedSteps[index]
                  ? 'bg-gray-800 text-white shadow-md'
                  : 'bg-white border-2 border-gray-300 text-gray-500 shadow-sm'
              }`}
            >
              {completedSteps[index] ? (
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                renderIcon(step.icon, currentStep === step.id, completedSteps[index])
              )}
            </div>
            
            <span className={`mt-3 text-sm font-medium transition-colors duration-300 ${
              currentStep === step.id 
                ? 'text-black' 
                : completedSteps[index]
                ? 'text-gray-800'
                : 'text-gray-500'
            }`}>
              {step.name}
            </span>
            
            {currentStep === step.id && (
              <div className="absolute -bottom-2 w-2 h-2 bg-black rounded-full animate-pulse"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator; 